<div class="page-container">
  <app-theme-toggle class="auth-theme-toggle" />
  <div class="center-column">
    <div class="content-container">
      <div class="auth-brand">
        <app-mira-logo class="auth-brand-logo" [width]="48" [height]="48" />
        <span class="auth-brand-name"><span class="auth-brand-box">box</span><span class="auth-brand-dot">.</span><span class="auth-brand-moe">moe</span></span>
      </div>
      <header>{{title}}</header>
      <app-flow [flow]="flow" (submit)="onSubmit($event)" [enableCaptcha]="true"></app-flow>
      @if (aal || refresh) {
        <div class="extra-action">
          <app-logout></app-logout>
        </div>
      }
      @if (!aal && !refresh) {
        <div class="extra-action">
          <a class="ui basic button" [routerLink]="['/registration']" [queryParams]="registrationQueryParams">Create account</a>
          <div class="ui horizontal divider">
            Or
          </div>
          <a class="recovery-link" [routerLink]="['/recovery']" [queryParams]="recoveryQueryParams">Recover your account</a>
        </div>
      }
    </div>
  </div>
</div>
